import { Link, Typography } from '@ori-ui/mui';
import { useEnvironment } from '@ori/environment';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { useFooter } from '../../hooks';
import { MobileAppIcon } from './components/MobileAppIcon';
import { SuperApp } from './components/SuperApp';
import { APP_ICON, MOBILE_APPS } from './constants';
import { Root, Icon, Icons } from './styles';

export const MobileApps: FC = () => {
  const { getTestId } = useTestId();
  const { mobileApps, ourApps } = useFooter();
  const { tenant } = useEnvironment();

  if (!ourApps || !mobileApps) {
    return null;
  }

  return (
    <Root data-testid={getTestId(MOBILE_APPS)}>
      <Typography
        variant="h5"
        component="h5"
      >
        {mobileApps.pageHeader?.title}
      </Typography>
      {tenant === 'cn' ? (
        <Icons>
          <Icon data-testid={getTestId(APP_ICON)}>
            <SuperApp />
          </Icon>
        </Icons>
      ) : (
        <>
          <Icons>
            {mobileApps.mobileAppCollection.map((app, index) => (
              <Icon
                key={app.title ?? index}
                data-testid={getTestId(APP_ICON)}
              >
                <MobileAppIcon
                  title={app.title ?? ''}
                  titleImage={app.titleImage ?? ''}
                />
              </Icon>
            ))}
          </Icons>
          <Link
            textTransform="uppercase"
            fontWeight="bold"
            color="textPrimary"
            href={ourApps.url ?? '#'}
            align="center"
          >
            {ourApps.title ?? ''}
          </Link>
        </>
      )}
    </Root>
  );
};
